import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";

import { ApplicationState } from "../../store/ApplicationState";
import { getConfigs, getConfigVariables } from "../../actions/AppConfigs";
import App from "../components";
import { getAccessControlId, saveRouteUrlInfo } from "../../actions/User";
import { RouteUrlInfo } from "../../models/User";
import { withErrorBoundary } from "../../components/custom/structure/components/ErrorBoundary";
import ErrorFallback from "../../components/custom/structure/components/ErrorFallback";
import { AppConfigsDispatchTypes } from "../../models/DispatchTypes/AppConfigs";

const mapStateToProps = ({
  userModuleState,
  UserPermissionState,
  RouteUrlInfoState,
  permissionState,
  appConfigVariableState
}: ApplicationState) => ({
  config: appConfigVariableState.response,
  moduleData: userModuleState,
  userPermission: UserPermissionState.response,
  routeUrlInfo: RouteUrlInfoState.response,
  permissionState: permissionState.response
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<
    ApplicationState,
    Record<string, never>,
    AppConfigsDispatchTypes>
) => {
  return {
    getConfig: (configFileName: string) => {
      dispatch(getConfigs(configFileName));
    },
    saveRouteUrlInfo: (routeUrlInfo: RouteUrlInfo) => {
      dispatch(saveRouteUrlInfo(routeUrlInfo));
    },
    getAccessControlId: (controlIds: string[]) => {
      dispatch(getAccessControlId(controlIds));
    }, 
    getConfigVariables: () => { 
      dispatch(getConfigVariables());
    }
  };
};
const ConnectedApp = connect(mapStateToProps, mapDispatchToProps)(App);

ConnectedApp.displayName = "UI Application";

export default withErrorBoundary(ConnectedApp, {
  fallback: ErrorFallback,
});